import axios from "axios";
import ApiMiner from "./client/ApiMiner";
import { ApiMinerAccount } from "./client/Accounts";
import { ApiMinerEvent, ApiMinerTransaction } from "./client/Transactions";
import { ApiMinerBlock } from "./client/Network";
import { ApiMinerRawEvent } from "./client/Contracts";
import { ApiMinerTokenInfo, ApiMinerTokenTransfer } from "./client/Tokens";
import axiosRateLimit from "@hokify/axios-rate-limit";

/**
 * @returns {ApiMiner}
 */
export function getApiMinerClient(baseUrl: string, accessToken?: string, requestsPerSecond = 0) {
    let client = axios.create({
        maxContentLength: 1000000,
        paramsSerializer: {
            indexes: null,
        },
        baseURL: baseUrl,
    });

    if (requestsPerSecond) {
        client = axiosRateLimit(client, {
            maxRPS: requestsPerSecond,
        });
    }

    return new ApiMiner(client, accessToken);
}

export {
    ApiMiner,
    ApiMinerTokenTransfer,
    ApiMinerTokenInfo,
    ApiMinerEvent,
    ApiMinerRawEvent,
    ApiMinerBlock,
    ApiMinerAccount,
    ApiMinerTransaction,
};

export * from "./CachedContractsApi";
export * from "./client/Contracts";
export * from "./client/Accounts";
export * from "./client/Network";
export * from "./client/Tokens";
export * from "./client/Transactions";
export * from "./client/Users";
export * from "./TypeMap";
export * from "@blockwell/apiminer";
